<template>
    <div>
        <b-card class="m-0" no-body>
            <b-card-header class="d-flex justify-content-between align-items-center">
                <h5 class="modal-title">{{ isKonfirmasi ? 'Konfirmasi' : '' }} Stock Opname</h5>
            </b-card-header>
            <b-card-body v-if="isKonfirmasi">
                <p>Stock by System sejumlah {{ inventoryPendukung ? formatNumberStrict(parseInt(inventoryPendukung.stock)) : '' }}.</p>
                <p>Stock Fisik sejumlah {{ formatNumberStrict(parseInt(form.stock)) }}.</p>
            </b-card-body>
            <b-card-body v-show="!isKonfirmasi">
                <div class="form-group">
                    <label>Stock Fisik</label>
                    <input v-validate="'required|min:0'" min="0" v-model="form.stock" type="number" name="stock_fisik" class="form-control">
                    <span class="text-danger">{{ errors.first('stock_fisik') }}</span>
                </div>
            </b-card-body>
            <b-card-footer class="d-flex flex-row-reverse">
                <template v-if="isKonfirmasi">
                    <button :disabled="isLoading" @click="koreksi" type="button" class="btn btn-secondary">Koreksi</button>
                    <button :disabled="isLoading" @click="save" type="button" class="btn btn-primary mr-2">OK</button>
                </template>
                <template v-else>
                    <button :disabled="isLoading" @click="$emit('cancel')" type="button" class="btn btn-secondary" data-dismiss="modal">Batal</button>
                    <button :disabled="isLoading" @click="konfirmasi" type="button" class="btn btn-primary mr-2">Simpan</button>
                </template>
            </b-card-footer>
        </b-card>
    </div>
</template>

<script>
export default {
    name: "inventory-pendukung-form",

    props: {
        inventoryPendukung: {
            type: Object,
            default: () => {},
        },

        value: {
            type: Object,
            default: () => {},
        },
    },

    components: {
    },

    data() {
        return {
            form: {
                stock: null,
            },
            isKonfirmasi: false,
        }
    },

    created() {
        this.resetForm();
    },

    mounted() {
        this.resetForm();
    },

    computed: {
    },

    watch: {
    },

    methods: {
        resetForm() {
            this.form = Object.assign({}, {
                stock: this.inventoryPendukung ? this.inventoryPendukung.stock : null,
            });

            if (this.inventoryPendukung && this.inventoryPendukung.opname) {
                this.form.stock = this.inventoryPendukung.opname.stock;
            }

            if (this.value) {
                this.form.stock = this.value.stock;
            }
        },

        konfirmasi() {
            let self = this;

            if (self.value) {
                self.save();
                return;
            }

            self.$validator.validateAll().then(result => {
                if (result) {
                    self.isKonfirmasi = true;
                }
            });
        },

        koreksi() {
            this.isKonfirmasi = false;
        },

        save() {
            let self = this;

            self.isLoading = true;

            let data = {
                stock: self.form.stock,
            }

            let api = self.value ? '/api/inventory-pendukungs/'+self.inventoryPendukung.id+'/stock-opname/'+self.value.id : '/api/inventory-pendukungs/'+self.inventoryPendukung.id+'/stock-opname';

            self.$Progress.start();
            axios({
                method: self.value ? 'put' : 'post',
                url: api,
                data: data,
            })
            .then(function (response) {
                Toast.fire({
                    icon: 'success',
                    title: response.data.message
                });
                self.isLoading = false;
                self.$Progress.finish();
                self.$emit('saved', response.data.data);
            })
            .catch(function (error) {
                self.requestFailed(error);
            });
        },
    },
}
</script>
